import axios, { AxiosResponse, AxiosError } from 'axios'
import { Dispatch } from 'redux'

import { API_REQUEST, API_REQUESTS } from '../actions/api'
import { to } from '../../utils/to'
import { ApiRequestAction, ApiRequestsAction } from '../types/api'
import { SET_CURRENT_USER } from '../actions/ui'

const api =
  ({ dispatch }: { dispatch: Dispatch }) =>
  (next: Dispatch) =>
  async (action: ApiRequestAction | ApiRequestsAction) => {
    const result = next(action)

    if (action.type === `[command] ${(action as ApiRequestAction)?.meta?.entity}/${API_REQUEST}`) {
      const { onSuccess, onError, originalPayload } = action.meta
      const [error, response] = await to<AxiosResponse, AxiosError>(axios(action.payload))

      if (error) {
        if (error.response?.status === 401) {
          dispatch({
            type: SET_CURRENT_USER,
            payload: error,
          })
        }
        dispatch({
          type: onError,
          payload: error,
          meta: { originalPayload },
        })
      }
      if (response) {
        dispatch({
          type: onSuccess,
          payload: response,
          meta: { originalPayload },
        })
      }
    }

    if (
      action.type === `[command] ${(action as ApiRequestsAction)?.meta?.entity}/${API_REQUESTS}`
    ) {
      const { onSuccess, onError, originalPayload } = action.meta
      const [errorArr, responseArr] = await to(
        axios.all(
          (action as ApiRequestsAction).payload.urls.map((urlItem) =>
            axios.get(urlItem.address, {
              data: urlItem.urlMeta,
            })
          )
        )
      )
      if (errorArr) {
        dispatch({
          type: onError,
          payload: errorArr,
          meta: { originalPayload },
        })
      }
      if (responseArr) {
        dispatch({
          type: onSuccess,
          payload: responseArr,
          meta: { originalPayload },
        })
      }
    }

    return result
  }

export const apiMiddlewares = [api]
